export const openUrlInNewTab = (url: string) => window.open(url, '_blank', 'noopener,noreferrer');

export const addPathDepth = (path: string, depth: number) =>
  new Array(depth).fill('../').join('') + path;

export const getFileName = (url: string): string | null => {
  try {
    const urlObject = new URL(url);
    const pathParts = urlObject.pathname.split('/');
    return pathParts[pathParts.length - 1];
  } catch {
    return null;
  }
};
